import Ten99s from 'Agent/1099s/components/1099';
import Ten99sV2 from 'Agent/1099s/components/1099_v2';
import {changeTen99Filters, EmptyTen99Filter} from 'Agent/1099s/ducks/1099';
import {
  changeTen99Filters as changeTen99Filters_V2, 
  EmptyTen99Filter as EmptyTen99Filter_V2,
} from 'Agent/1099s/ducks/1099_v2';
import {FeatureConstants} from 'Core/ducks/featureFlag';
import Ten99RouteConstants from 'Agent/1099s/Ten99RouteConstants';
import {ReducerState} from 'rootReducer';
import React from 'react';
import {useSelector} from 'react-redux';
import {Route, RouteComponentProps} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';

type Ten99RouteProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({match, selectedAgency}: Ten99RouteProps) => {
  const {ENABLE_TAX_PORT_YEAR_FILTER, resolvedFeatures} = useSelector((state: ReducerState) => state.featureFlag);
  const isTaxYearFilterFlagResolved = !!resolvedFeatures?.[FeatureConstants.ENABLE_TAX_PORT_YEAR_FILTER];

  useOnNavigateAway(Ten99RouteConstants.TEN99s, () =>
    ENABLE_TAX_PORT_YEAR_FILTER
      ? changeTen99Filters_V2(EmptyTen99Filter_V2)
      : changeTen99Filters(EmptyTen99Filter)
  );

  if (!isTaxYearFilterFlagResolved) {
    return null;
  }

  if(ENABLE_TAX_PORT_YEAR_FILTER){
    return (
      <Route
        exact
        path={`${match.url}/taxStatements`}
        render={routeProps => <Ten99sV2 {...routeProps} selectedAgency={selectedAgency} />}
      />
    );
  } else {
    return (
      <Route
        exact
        path={`${match.url}/taxStatements`}
        render={routeProps => <Ten99s {...routeProps} selectedAgency={selectedAgency} />}
      />
    );
  }
};
